(function () {
  const intiSlider = (section) => {
    const sliderEl = section.querySelector(".js-slider-brands");
    if (!sliderEl) return;

    const wrapper = sliderEl.querySelector(".swiper-wrapper");
    const original = Array.from(sliderEl.querySelectorAll(".swiper-slide"));
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /*
      This runs as a CSS marquee rather than a Swiper autoplay. Swiper was tried
      first and sat inert: with slidesPerView auto and loop on, even an explicit
      slideNext() left the transform at 0, so the belt never moved. A logo wall
      does not need drag or snapping, and an animation cannot stall.

      Seamless looping needs the track to hold exactly two identical halves, so
      the logos are repeated enough times to overflow the viewport, then that
      whole run is duplicated once. Sliding by -50% lands precisely back on the
      start, with no jump at the seam.
    */
    const canMarquee = original.length > 1 && !reduceMotion && wrapper;

    if (!canMarquee) {
      new Swiper(sliderEl, {
        slidesPerView: "auto",
        spaceBetween: 8,
        mousewheel: { forceToAxis: true },
      });
      return;
    }

    /*
      Order matters here. The marquee class has to go on before anything is
      measured, because it changes the track layout: without it the wrapper is
      still styled by Swiper and reports a width that has nothing to do with how
      the logos finally sit. Measuring first read 1860px for a run that settles
      at 964px, which made one pass look like plenty and left a gap sliding
      through the loop.
    */
    sliderEl.classList.add("brands__logo-list--marquee");

    const build = () => {
      /*
        Each half must be at least as wide as the viewport, or the belt runs out
        of logos before the seam comes round. 1.2x leaves a little margin.
      */
      const target = Math.max(sliderEl.clientWidth, window.innerWidth) * 1.2;
      wrapper.replaceChildren();

      let halfWidth = 0;
      let passes = 0;
      while ((halfWidth < target || passes === 0) && passes < 12) {
        original.forEach((slide) => wrapper.appendChild(slide.cloneNode(true)));
        halfWidth = wrapper.scrollWidth;
        passes += 1;
      }

      const mirror = document.createDocumentFragment();
      for (let i = 0; i < passes; i += 1) {
        original.forEach((slide) => {
          const clone = slide.cloneNode(true);
          clone.setAttribute("aria-hidden", "true");
          clone.querySelectorAll("a").forEach((a) => a.setAttribute("tabindex", "-1"));
          mirror.appendChild(clone);
        });
      }
      wrapper.appendChild(mirror);

      /*
        The shift is the gap between the first slide and its twin at the head of
        the mirrored run, taken straight off the laid-out track. A -50% shift is
        the obvious alternative and it is wrong by a few pixels: percentage
        widths and scrollWidth each drop the last slide's trailing margin, which
        shows up as a small stutter every time the loop comes round.
      */
      const kids = wrapper.children;
      const seam = kids[passes * original.length];
      const shift = seam.getBoundingClientRect().left - kids[0].getBoundingClientRect().left;
      wrapper.style.setProperty("--marquee-shift", `${shift}px`);

      // Roughly 60px a second, so a longer logo list takes proportionally longer
      // rather than whipping past.
      wrapper.style.setProperty("--marquee-duration", `${Math.max(12, Math.round(shift / 60))}s`);
    };

    // Logo widths are only real once the images are decoded, so hold off until
    // the page has finished loading rather than measuring empty boxes.
    if (document.readyState === "complete") {
      build();
    } else {
      window.addEventListener("load", build, { once: true });
    }

    /*
      The shift is a pixel figure taken from one layout, and card widths change
      at the 576px breakpoint. A phone turned sideways would leave the belt
      travelling the old distance and the seam would stop lining up. Only a real
      width change triggers a remeasure, so the address bar sliding away during a
      mobile scroll does not set this off.
    */
    let lastWidth = window.innerWidth;
    let resizeTimer;
    window.addEventListener("resize", () => {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(build, 200);
    });
  };

  const initSection = (section) => {
    if (!section || !section?.classList.contains("section-brands")) {
      return;
    }

    intiSlider(section);
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
